'use client';

import { c as _c } from "react/compiler-runtime";
import { Label } from '@/components/ui/label';
import { MultiSelect } from '@/components/ui/multi-select'; // Adjust path if needed
import { useGenerateKeyFeatures } from '@/store/generate';
export const gardenFeaturesOptions = [{
  value: 'pond',
  label: 'Pond',
  emoji: '💧'
}, {
  value: 'furniture',
  label: 'Garden Furniture',
  emoji: '🪑'
}, {
  value: 'tree',
  label: 'Large Tree',
  emoji: '🌳'
}, {
  value: 'flower-bed',
  label: 'Flower Bed',
  emoji: '🌸'
}, {
  value: 'vegetable-patch',
  label: 'Vegetable Patch',
  emoji: '🥕'
}, {
  value: 'playground',
  label: 'Play Area',
  emoji: '🤸'
}, {
  value: 'canopy',
  label: 'Covered Patio/Veranda',
  emoji: '⛱️'
}, {
  value: 'shed',
  label: 'Shed/Storage',
  emoji: '🏡'
}];
export const getKeyFeaturesDisplay = values => {
  if (!Array.isArray(values)) return String(values);
  return values.map(value => {
    const feature = gardenFeaturesOptions.find(f => f.value === value);
    return feature ? `${feature.emoji} ${feature.label}` : value;
  }).join(', ');
};
const selectOptions = gardenFeaturesOptions.map(feature => ({
  value: feature.value,
  label: `${feature.emoji} ${feature.label}`
}));
export function KeyFeatureSelect() {
  const $ = _c(4);
  const {
    keyFeatures,
    setKeyFeatures
  } = useGenerateKeyFeatures();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Label htmlFor="keyFeature" className="mb-1.5 block text-sm font-semibold text-gray-700">Key features</Label>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== keyFeatures || $[2] !== setKeyFeatures) {
    t1 = <div>{t0}<MultiSelect options={selectOptions} onValueChange={setKeyFeatures} value={keyFeatures} placeholder="Select key features..." className="w-full" name="keyFeatures" /></div>;
    $[1] = keyFeatures;
    $[2] = setKeyFeatures;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}